import { connect } from 'react-redux';

import { themeSelector } from 'selectors/themeSelector';

import { Main } from './Main';

const mapStateToProps = (state, ownProps) => themeSelector(state, ownProps);

export const MainContainer = connect(mapStateToProps, null)(Main);
